export default __webpack_public_path__ + "images/assets/bd70a0c8794cb35630fe49eda9d47f86.svg";